import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';

/**
 * The privacy policy of Dock Town, the macOS menu bar app, at /plugins/macos/dock-town/privacy
 * (linked from the app's page). It says what the app does with data and nothing beyond it:
 * when the app changes how it handles data, change the text and the effective date together.
 */
@Component( {
  selector: 'app-dock-town-privacy-page',
  templateUrl: './dock-town-privacy-page.component.html',
  styleUrls: [ './dock-town-privacy-page.component.scss' ]
} )
export class DockTownPrivacyPageComponent {

  URLS = URLS;

  environmentCommon = environmentCommon;

  // Apple's standard licence for App Store apps: Dock Town's Terms of Use.
  readonly eulaUrl = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

  constructor() {
    // Intentionally Blank
  }
}
